
























































import Vue from 'vue';

export default Vue.extend({
    created() {
        window.FRSToolV3.getConfig({ page: 'global', type: 'fundPage' }).then((res: any) => {
            let urlLength = res.result.length - 3;
            this.baseUrl = res.result.substr(0, urlLength);
        });
        window.FRSToolV3.getLastViewedItems().then((res: any) => {
            this.historyData = res.result;
        });
    },
    data() {
        return {
            historyHeader: ['名稱', '晨星評等', '三個月', '六個月', '一年', '兩年', '三年', '成立至今'],
            historyData: [],
            baseUrl: ''
        };
    },
    methods: {
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
